import React, { createContext, useContext, useState } from "react";

const ModalContext = createContext(null);

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
    const [active, setActive] = useState(null); // 'contact' | 'login' | 'faq' | 'disclaimer' | 'book' | 'portal-login'
    const [payload, setPayload] = useState(null);
    return (
        <ModalContext.Provider
            value={{
                active,
                payload,
                open: (key, data = null) => { setActive(key); setPayload(data); },
                close: () => { setActive(null); setPayload(null); },
            }}
        >
            {children}
        </ModalContext.Provider>
    );
};
